export const deliverySelector = state => state.delivery;
